/** Status-to-className mapping utilities — replaces nested ternaries. */

const STATUS_COLORS = {
  approved: "bg-emerald-100 text-emerald-700 border-emerald-200",
  active: "bg-emerald-100 text-emerald-700 border-emerald-200",
  completed: "bg-emerald-100 text-emerald-700 border-emerald-200",
  review: "bg-blue-100 text-blue-700 border-blue-200",
  pending: "bg-amber-100 text-amber-700 border-amber-200",
  revision: "bg-orange-100 text-orange-700 border-orange-200",
  rejected: "bg-red-100 text-red-700 border-red-200",
  draft: "bg-slate-100 text-slate-600 border-slate-200",
  signing: "bg-violet-100 text-violet-700 border-violet-200",
  archived: "bg-slate-100 text-slate-500 border-slate-200",
};

const STEP_COLORS = {
  approved: "bg-emerald-100 border-emerald-400",
  rejected: "bg-red-100 border-red-400",
  pending: "bg-amber-50 border-amber-300",
  "sent-back": "bg-orange-50 border-orange-300",
};

const URGENCY_COLORS = {
  critical: "bg-red-100 text-red-700",
  high: "bg-amber-100 text-amber-700",
  medium: "bg-blue-100 text-blue-700",
  low: "bg-slate-100 text-slate-600",
};

export function statusColor(status, fallback = "bg-slate-100 text-slate-600") {
  return STATUS_COLORS[status?.toLowerCase()] || fallback;
}

export function stepColor(status) {
  return STEP_COLORS[status?.toLowerCase()] || "bg-slate-50 border-slate-200";
}

export function urgencyColor(level) {
  return URGENCY_COLORS[level?.toLowerCase()] || URGENCY_COLORS.low;
}

export function daysUrgencyColor(days) {
  if (days <= 7) return "bg-red-100 text-red-700";
  if (days <= 30) return "bg-amber-100 text-amber-700";
  return "bg-blue-100 text-blue-700";
}
